var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NotificationNameTypes, NotificationStateTypeConstants } from 'vrlcm-gui-types';
import { l10n } from '../i18n/i18nUtil';
export var notificationNameToFriendlyName = function (name) {
    switch (name) {
        case NotificationNameTypes.PASSWORD_EXPRIY:
            return l10n('notification.passwordExpiry');
        case NotificationNameTypes.LcmPsPack:
            return l10n('notification.lcmPSPack');
        case NotificationNameTypes.LcmUpgrade:
            return l10n('notification.lcmUpgrade');
        case NotificationNameTypes.LcmPatch:
            return l10n('notification.lcmPatch');
        case NotificationNameTypes.ProductUpgrade:
            return l10n('notification.productUpgrade');
        case NotificationNameTypes.ProductPatch:
            return l10n('notification.productPatch');
        case NotificationNameTypes.Health:
            return l10n('notification.health');
        case NotificationNameTypes.VIDM_POSTGRES_CLUSTER_HEALTH:
            return l10n('notification.vidmPostgresHealth');
        case NotificationNameTypes.PRODUCT_REPLACE_CERTIFICATE:
            return l10n('notification.productReplaceCertificate');
        case NotificationNameTypes.LCM_VCF_FIPS_STATUS:
            return l10n('notification.lcmSddcFipsStatus');
        case NotificationNameTypes.LCM_LICENSE_HEALTH:
            return l10n('notification.licenseHealth');
        case NotificationNameTypes.LCM_CERTIFICATE_HEALTH:
            return l10n('notification.certificateHealth');
        case NotificationNameTypes.LCM_LICENSE_CONNECTION_STATUS:
            return l10n('notification.licenseConnectionStatus');
        case NotificationNameTypes.PERPETUAL_LICENSE_OFFSET:
            return l10n('notification.perpetualLicenseOffset');
        default:
            return name;
    }
};
export var iconShapeForNotification = function (name, level) {
    switch (name) {
        case NotificationNameTypes.PASSWORD_EXPRIY:
            return 'lock';
        case NotificationNameTypes.LcmPsPack:
            return 'scroll';
        case NotificationNameTypes.LcmUpgrade:
            return 'circle-arrow';
        case NotificationNameTypes.LcmPatch:
            return 'wrench';
        case NotificationNameTypes.ProductPatch:
            return 'wrench';
        case NotificationNameTypes.ProductUpgrade:
            return 'circle-arrow';
        case NotificationNameTypes.Health:
        case NotificationNameTypes.LCM_LICENSE_HEALTH:
        case NotificationNameTypes.LCM_CERTIFICATE_HEALTH:
            return 'line-chart';
        case NotificationNameTypes.VIDM_POSTGRES_CLUSTER_HEALTH:
            if (level === 'ERROR') {
                return 'cluster';
            }
            return 'cluster';
        case NotificationNameTypes.PRODUCT_REPLACE_CERTIFICATE:
            return 'certificate';
        default:
            return 'info-standard';
    }
};
export var iconClassForNotification = function (name, level) {
    switch (name) {
        case NotificationNameTypes.PASSWORD_EXPRIY:
            return 'notification-item-icon-password-expiry';
        case NotificationNameTypes.ProductPatch:
            return 'notification-item-icon-product-patch';
        case NotificationNameTypes.LcmPatch:
            return 'notification-item-icon-product-patch';
        case NotificationNameTypes.LcmUpgrade:
            return 'notification-item-icon-lcm-upgrade';
        case NotificationNameTypes.ProductUpgrade:
            return 'notification-item-icon-product-upgrade';
        case NotificationNameTypes.LcmPsPack:
            return 'notification-item-icon-ps-pack';
        case NotificationNameTypes.Health:
        case NotificationNameTypes.LCM_LICENSE_HEALTH:
        case NotificationNameTypes.LCM_CERTIFICATE_HEALTH:
            return 'notification-item-icon-health';
        case NotificationNameTypes.VIDM_POSTGRES_CLUSTER_HEALTH:
            if (level === 'ERROR') {
                return 'notification-item-icon-vidm-health-error';
            }
            return 'notification-item-icon-vidm-health-ok';
        case NotificationNameTypes.PRODUCT_REPLACE_CERTIFICATE:
            return 'notification-item-icon-product-replace-certificate';
    }
};
export var isNotificationRead = function (notification) {
    return notification.state === NotificationStateTypeConstants.CREATED;
};
export var mapNotificationDTO = function (n) {
    return n.redirectUrl === '/settings/update'
        ? __assign(__assign({}, n), { redirectUrl: '/settings/system-administration/update' }) : n;
};
